import React from 'react';
import {withTranslation} from 'react-i18next';
import {Button, ModalFooter} from 'shards-react';
import './Modals.css';
import {Modal} from 'react-bootstrap';
import {FailureIcon, InfoIcon, SuccessIcon} from '../AnimatedIcons/AnimatedIcons';
import {BeatLoader} from 'react-spinners';
import {logEvent} from '../../utils/firebase';
import {snakeCase} from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
import {IconButton} from '@mui/material';

/* Props
 stage -> [content, loading, success, loading]
 open -> bool
 content -> component
 successMessage -> string
 failureMessage -> string
 infoMessage -> string
 buttonTheme -> string
 buttonText -> component / string
 modalTitle -> string
 update -> function (pass to parent)

 */

class BaseModal extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      open: this.props.open,
      stage: this.props.stage,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.stage !== prevProps.stage) {
      this.setState({stage: this.props.stage});
    }
    if (this.props.open !== prevProps.open) {
      if (this.props.open) {
        logEvent(`${snakeCase(this.props.name)}_modal_open`);
      }
      this.setState({open: this.props.open});
    }
  }

  toggle() {
    if (this.props.open && this.props.success === 3) {
      this.props.update();
    }
    this.setState({
      stage: 'content',
    });
    this.props.onToggle();
  }

  showModalContent() {
    const style = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '216px',
    };
    /*eslint-disable*/
    switch (this.state.stage) {
      case 'content':

        return this.props.content;

      case 'loading':
        return (
          <div style={style}>
            <BeatLoader size={30} color={'#00be68'} />
          </div>
        );
      case 'success':
        setTimeout(() => {
          this.props.onToggle(false);

        }, 1500);
        return (
          <div style={style}>
            <SuccessIcon />
            <ModalFooter>{this.props.successMessage}</ModalFooter>
          </div>
        );
      case 'info':
        return (
          <div style={style}>
            <InfoIcon />
            <ModalFooter>{this.props.infoMessage}</ModalFooter>
          </div>
        );
      case 'failure':
        return (
          <div style={style}>
            <FailureIcon />
            <ModalFooter>{this.props.failureMessage}</ModalFooter>
          </div>
        );
    }
  }

  render() {

    return (
      <React.Fragment>
        {this.props.noButton || (
          <Button
            block={this.props.size !== 'small'}
            theme={this.props.buttonTheme}
            disabled={this.props.disabled}
            outline={this.props.outline}
            size='lg'
            className={this.props.size === 'small' ? '' : 'mt-2 p-2'}
            onClick={this.toggle}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: this.props.size !== 'small' ? '53.1944px' : '',
              fontSize: '15px',
              ...this.props.buttonStyle,
            }}
          >
            {this.props.buttonText}
          </Button>
        )}
        <Modal
          show={this.props.open}
          onHide={this.toggle}
          style={{display: 'flex', zIndex: 9998}}
          dialogClassName={this.props.customClass}
          size={this.props.modalSize || 'lg'}
          centered

        >
          <Modal.Header style={{paddingBottom: 4, paddingTop: 4, alignItems: 'center'}}>
            {this.props.modalTitle}
            <IconButton onClick={this.toggle}>
              <CloseIcon />
            </IconButton>
          </Modal.Header>
          <Modal.Body className={this.props.modalBodyClassName} style={this.props.modalBodyStyles}>
            {this.showModalContent()}
          </Modal.Body>
          {this.state.stage !== 'content' && this.state.stage !== 'loading' ? (
            <Modal.Footer>
              <Button block onClick={this.toggle} theme='success'>
                {this.props.t('modals:base_modal_close')}
              </Button>
            </Modal.Footer>
          ) : null}
        </Modal>
      </React.Fragment>
    );
  }
}

export default withTranslation('modals')(BaseModal);
